import type { ReactNode } from 'react'

/** Split screen for the unauthenticated screens. The brand panel drops away */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh">
      <aside className="hidden w-2/5 flex-col justify-between bg-primary-strong p-10 text-on-primary lg:flex">
        <div className="flex flex-col gap-1">
          <p className="text-display font-semibold">Paisa24</p>
          <p className="text-h2">Control Panel</p>
        </div>
        <p className="max-w-sm text-base">
          Lead and conversation management for the Paisa24 AI assistant.
        </p>
        <div className="flex flex-col gap-0.5 text-xs">
          <p>Barota Finance Limited</p>
          <p>Built by Samyora</p>
        </div>
      </aside>

      <main className="flex flex-1 flex-col items-center justify-center gap-6 bg-sunken px-6 py-10">
        <div className="w-full max-w-sm rounded-lg border border-line bg-surface p-6">{children}</div>
        <p className="max-w-sm text-center text-xs text-subtle">
          Authorised access only. All activity on this panel is recorded.
        </p>
      </main>
    </div>
  )
}
